import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Skeleton } from '@material-ui/lab'
import { range } from 'lodash'

const useStyles = makeStyles(theme => ({
  loadingStateRoot: {
    marginTop: 20,
    padding: 16
  },
  notificationSkeleton: {
    borderRadius: '8px',
    width: '100%',
    height: '83px',
    background: '#EEEEEE',
    marginBottom: 12
  }
}))

const NotificationCenterLoadingState = () => {
  const classes = useStyles()

  return (
    <div className={classes.loadingStateRoot}>
      {range(10).map(index => (
        <Skeleton key={index} variant="rect" className={classes.notificationSkeleton} />
      ))}
    </div>
  )
}

export default NotificationCenterLoadingState
